import React, { useState } from "react";
import GoogleMapReact, { ChangeEventValue } from "google-map-react";
import "./index.scss";

const GoogleMapsApiKey = "AIzaSyA4fU-amPNj1ormn2JI1usNzSxHEiwcoA4";

type MapInputPropsType = {
  latitude?: number;
  longitude?: number;
  mapStyle?: string;
  defaultZoomLevel?: number;
  children?: any;
  onGoogleMapsApiHandler?: Function;
  onChange?: (evt: ChangeEventValue) => void;
  markers?: Array<any>;
};

const GoogleMapsComponent = ({
  latitude,
  longitude,
  mapStyle,
  defaultZoomLevel,
  children,
  onGoogleMapsApiHandler,
  onChange,
}: MapInputPropsType) => {
  const [viewState, setViewState] = useState({
    latitude: latitude || 10.77653,
    longitude: longitude || 106.700981,
    zoom: defaultZoomLevel || 15,
    pitch: 0,
    bearing: 0,
  });
  const handleApiLoaded = (map: any, maps: any) => {
    if (onGoogleMapsApiHandler) {
      onGoogleMapsApiHandler(map, maps);
    }
  };
  const createMapOptions = (maps: any) => {
    return {
      fullscreenControl: false,
      styles: [
        {
          stylers: [
            // { saturation: -100 },
            // { gamma: 0.8 },
            // { lightness: 4 },
            // { visibility: "on" },
          ],
        },
      ],
    };
  };
  return (
    <GoogleMapReact
      options={createMapOptions}
      bootstrapURLKeys={{
        key: GoogleMapsApiKey,
        libraries: ["places", "geometry", "drawing", "visualization"],
        version: "3.64",
      }}
      defaultCenter={{ lat: viewState.latitude, lng: viewState.longitude }}
      defaultZoom={viewState.zoom}
      onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      yesIWantToUseGoogleMapApiInternals
      onChange={onChange}
      onMapTypeIdChange={(val) => console.log(val)}
    >
      {children}
    </GoogleMapReact>
  );
};

export default GoogleMapsComponent;
